import { isArsMasterReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { getDuplicateVariantName } from "functions/tlf/getDuplicateVariantName";
import { groupVariantPatches } from "functions/tlf/groupVariantPatches";
import { ITlfActionUpsertVariantTemplate, TlfContextProps, UPDATE_TLF } from "./interface";
import { tlf_updateTlf } from "./tlf_updateTlf";

/**
 * Adds or updates a template's mutually compatible patch choices in unsaved TLF data.
 *
 * @param state - Current master TLF and persisted save point
 * @param action - Named template definition to retain until save or navigation discard
 * @returns Updated TLF state, or unchanged state for invalid or read-only edits
 */
export const tlf_upsertVariantTemplate = (
  state: TlfContextProps,
  action: ITlfActionUpsertVariantTemplate,
): TlfContextProps => {
  if (state.readOnly || !isArsMasterReadDto(state.tlfData)) return state;
  const current = state.tlfData;
  const name = action.template.name.trim();
  const variantPatches = action.template.variantPatches;
  if (
    name.length === 0 ||
    getDuplicateVariantName(current.variantTemplates, variantPatches, name) !== undefined ||
    variantPatches.some((patch) => !Object.hasOwn(current.allVariantPatches, patch)) ||
    groupVariantPatches(current).some(
      (group) => group.filter((patch) => variantPatches.includes(patch)).length > 1,
    )
  )
    return state;
  const template = { ...action.template, name, variantPatches };
  const exists = current.variantTemplates.some((entry) => entry.name === name);
  const variantTemplates = exists
    ? current.variantTemplates.map((entry) => (entry.name === name ? template : entry))
    : [...current.variantTemplates, template];
  return tlf_updateTlf(state, {
    operation: UPDATE_TLF,
    tlfData: { ...current, variantTemplates },
    calledFrom: action.calledFrom,
  });
};
